import { render } from "./Itinerario.vue?vue&type=template&id=f5be3f96&scoped=true"
import script from "./Itinerario.vue?vue&type=script&lang=js"
export * from "./Itinerario.vue?vue&type=script&lang=js"

import "./Itinerario.vue?vue&type=style&index=0&id=f5be3f96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sebastian\\Documents\\choferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5be3f96"]])

export default __exports__